import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../../Components/Header/Header';
import Sidebar from '../../Components/Sidebar/Sidebar';
import '../AdventureShared.css';

export default function PaymentCancel() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('bookingId');
  const type = searchParams.get('type');
  const certificationId = searchParams.get('certificationId');

  return (
    <div className="PaymentCallbackPage" style={{ color: '#ffffff', backgroundColor: '#071414', minHeight: '100vh' }}>
      <div className="adventurePageContainer">
        <div className="headerContain">
          <Header />
        </div>
        <div className="adventurePageContainer2">
          <div className="sidebarContain">
            <Sidebar />
          </div>
          <main className="adv-page-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '75vh' }}>
            <div 
              style={{
                background: 'rgba(14, 27, 27, 0.95)',
                border: '1.5px solid rgba(220, 53, 69, 0.25)',
                borderRadius: '16px',
                padding: '40px',
                width: '100%',
                maxWidth: '480px',
                textAlign: 'center',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.4)',
                animation: 'adv-fade-in 0.3s ease forwards'
              }}
            >
              <div 
                style={{
                  fontSize: '48px',
                  width: '80px',
                  height: '80px',
                  lineHeight: '80px',
                  background: 'rgba(220, 53, 69, 0.12)',
                  color: '#dc3545',
                  borderRadius: '50%',
                  margin: '0 auto 24px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold'
                }}
              >
                ✕
              </div>
              <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '12px', color: '#ffffff' }}>
                Payment Cancelled
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '24px' }}>
                The payment process was cancelled or was unable to complete. No funds have been deducted from your account.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
                <button
                  onClick={() => {
                    if (type === 'certification' && certificationId) {
                      navigate(`/certifications/${certificationId}`);
                    } else {
                      navigate(`/facilitate/orders/${bookingId}`);
                    }
                  }}
                  style={{
                    background: '#3bb3ae',
                    color: '#071414',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '15px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                   {type === 'certification' ? 'Return to Certification Details' : 'Return to Order Details'}
                </button>
                <button
                  onClick={() => {
                    if (type === 'certification') {
                      navigate('/certifications');
                    } else {
                      navigate('/facilitate/orders');
                    }
                  }}
                  style={{
                    background: 'transparent',
                    color: '#ffffff',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '8px',
                    padding: '10px 24px',
                    fontSize: '15px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                   {type === 'certification' ? 'Certifications List' : 'My Orders List'}
                </button>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
